import localforage from "localforage";

export const setCache = async (key: string, value: any) => {
  try {
    await localforage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error("Error saving cache:", error);
  }
};

export const getCache = async (key: string) => {
  try {
    const value = await localforage.getItem<string>(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    console.error("Error reading cache:", error);
    return null;
  }
};

export const clearCache = async (key: string) => {
  try {
    await localforage.removeItem(key);
  } catch (error) {
    console.error("Error clearing cache:", error);
  }
};
